import { analytics } from "@/instrument";

// Fire a PostHog event recording WHICH sign-up CTA a visitor tapped, so the
// admin analytics can see which button drives the most registrations.
// Consent-gated + PHI-safe: `analytics.capture` is a no-op until the visitor
// opts in via the cookie banner and scrubs all values.
export function trackSignupClick(source, extra = {}) {
  try {
    analytics?.capture?.("signup_cta_click", {
      source: source || "unknown",
      path: typeof window !== "undefined" ? window.location.pathname : "",
      ...extra,
    });
  } catch {
    /* noop — analytics must never break navigation */
  }
}
